<template>
  <div class="user">
    <!--导航栏-->
    <header-nav></header-nav>
    <!--个人中心导航-->
    <user-nav></user-nav>

    <div class="user-center">
      <el-tabs class="border-card-main" type="border-card">
        <el-tab-pane label="会员中心">
          <member></member>
        </el-tab-pane>
        <el-tab-pane label="修改密码">
          <personal></personal>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--底部-->
    <footer-box></footer-box>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index";
import userNav from "@/components/userNav/index";
import footerBox from "@/components/footerBox/index";
import member from "./components/member/index";
import personal from "./components/personal/index";
export default {
  name: "user",
  components: { headerNav, userNav, footerBox, member, personal },
  data() {
    return {
      dialogVisible: false,
      content: "",
      param: {
        page: 1,
        limit: 12,
      },
      total: 0,
    };
  },
  computed: {
    manystore() {
      return this.$store.getters.manystore || { order_ups_text: "" };
    },
  },
  mounted() {
    if (this.manystore.order_ups_text) {
      this.content = this.manystore.order_ups_text;
      this.dialogVisible = true;
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped>
.el-tabs--border-card {
  border: none;
  box-shadow: none;
}
.el-tabs__item {
  padding: 0 60px !important;
}
.el-tabs--border-card > .el-tabs__header {
  background-color: #e4e4e4;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item:hover {
  color: #000000 !important;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #000;
}
.dialog-box >>> .el-dialog {
  margin-top: 15vh !important;
}
.dialog-box >>> .el-dialog__body {
  height: 60vh !important;
}
</style>
<style scoped lang="scss">
.user {
  min-height: 100vh;
  position: relative;
  padding-bottom: 80px;
  // background-color: #eeeeee;

  .user-center {
    width: 1300px;
    margin: 0 auto;
    padding-left: 180px;

    .border-card-main {
      min-height: calc(100vh - 270px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/index.vue